module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9605.782137c6.jpg";